import React, { memo } from 'react';
import { Image } from 'antd';
import withZoomViewer from '../hoc/withZoomViewer';
import MediaPlaceholder from './MediaPlaceholder';

const ZoomableImage = withZoomViewer(Image);

interface ImageItemProps {
  src: string;
  title: string;

  onItemClick: (item: any) => void;
  onError?: () => void;
  zoomControls?: any;
  enableZoom?: boolean;
  isVideo?: boolean;
}

const ImageItem: React.FC<ImageItemProps> = memo(
  ({ src, title, onItemClick, onError, zoomControls, enableZoom = false, isVideo = false }) => {
    const ImageComponent = enableZoom ? ZoomableImage : Image;

    return (
      <div className="h-full w-full [&_.ant-image]:!block [&_.ant-image]:!h-full [&_.ant-image]:!w-full">
        <ImageComponent
          alt={title}
          src={src}
          {...(enableZoom && { zoomControls })}
          preview={false}
          placeholder={<MediaPlaceholder isVideo={isVideo} />}
          loading="lazy"
          className="!h-full !w-full"
          style={{
            objectFit: 'cover',
            width: '100%',
            height: '100%',
            cursor: 'pointer',
          }}
          onError={onError}
          onClick={onItemClick}
        />
      </div>
    );
  }
);

export default ImageItem;
